module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAAXNSR0IArs4c6QAAAMpJREFUGBlNkDEKwkAQRaPBgCIIFnYWgpVHsPYI1hZWdp5KEGwsPIFWtulED5ATmFLfixnZD29ndvJ3NrN5lmUr2MEQHpCqz2YLa6hyFo0jmMMYSlAa97Bo80KzHTWqKXjgCRpnEDp3yGQDy6gS3zBI9gfyq52VV9vRzqr3C83aGM26bfFDPIEdU73Y3KIQnWOYSXxoo7eJN2eaw5gOY0dNKoYuNfuOPk/IfzyC5pjBWGv2we2u/sOQe3V6oDFXFAs4wx1SeaBuuXwBZ7gibNP/TdwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/core/search/close.png
// module id = D8vO
// module chunks = 3